import { html } from 'lit';
import { TypeIcon } from '@outbook/webcomponents-type-icon';
import { expand_more } from '@outbook/icons';
import { isEventClick, isKeyEnterOrKeySpace } from '@outbook/a11y';

export function ButtonMoreContent({ eventFn = () => {}, text = 'More news' }) {
  function handleButton(ev) {
    if (isEventClick(ev) || isKeyEnterOrKeySpace(ev)) {
      ev.preventDefault();
      eventFn(ev);
    }
  }

  return html`
    <div class="flex justify-center mt-4 pb-2">
      <div
        tabindex="0"
        role="button"
        class="link inline-flex items-center text-xl cursor-pointer"
        @click="${handleButton}"
        @keydown="${handleButton}"
      >
        ${TypeIcon({ icon: 'current', icons: { current: expand_more }, size: 'S' })}
        <span>${text}</span>
      </div>
    </div>
  `;
}
